import { TextField } from "@mui/material";
import styled from "styled-components";

export const StyledInput = styled(TextField)``;

export const StyledLabel = styled.label`
  margin-top: 1rem;
  color: ${props => props.theme.colors.blackLight};
`;